import React, { useState, useEffect } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import { getloanCollectionReportMonthWiseBydate, SaveUpdateLockProvisionData, UpdateUnlockSummaryData } from '../DebtListActionCreator';
import Loader from '../../../../presentationals/Loader/Loader.component'
import Menubar from './Menubar'
import Popup from '../../../../presentationals/Popup/Popup.component'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
const InitalDate = (type) => {
    if (type === 'fromDate') {
        const year = new Date().getFullYear();
        const FirstDay = moment(`${year}-01-01`);
        const fromdate = FirstDay.format('YYYY-MM-DD');
        // const fromdate = moment().subtract(1, 'month').format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }

}


const generateMonthSection = () => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const start = new Date("2024-01-01");
    const now = new Date();

    const result = [];
    const current = new Date(start);

    while (current <= now) {
        result.push({
            monthName: monthNames[current.getMonth()],
            monthYear: current.getFullYear().toString()
        });
        current.setMonth(current.getMonth() + 1);
    }

    return result;
};

const getcurrentMonth = (type) => {
    const currentDate = new Date();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const currentMonthName = monthNames[currentDate.getMonth()];
    const currentYear = currentDate.getFullYear().toString();
    if (type == "name") {
        return currentMonthName
    } else if (type == "year") {
        return currentYear
    } else if (type === "monthlast") {
        const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        const day = String(lastDay.getDate()).padStart(2, '0');
        const month = String(lastDay.getMonth() + 1).padStart(2, '0');
        const year = lastDay.getFullYear();
        return `${day}-${month}-${year}`;
    }
}

const getLastDateOfMonth = (monthName, year) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Get the index of the month (0-based)
    const monthIndex = monthNames.findIndex(m => m.toLowerCase() === monthName.toLowerCase());

    if (monthIndex === -1) return null; // Invalid month

    // Get last day of the month
    const lastDate = new Date(year, monthIndex + 1, 0); // monthIndex + 1 and date 0 gives last date of previous month

    // Format as dd-mm-yyyy
    const day = String(lastDate.getDate()).padStart(2, '0');
    const month = String(lastDate.getMonth() + 1).padStart(2, '0');
    const fullYear = lastDate.getFullYear();

    return `${day}-${month}-${fullYear}`;
};


const StartMonthValue = "01-01-2024";

export default function ProvisionList({ admin, nbfcList, commonFilters, handleCommonFilters }) {


    const [viewType, setViewType] = useState("list")
    const [loader, setLoader] = useState(false)
    const [APIData, setAPIData] = useState([])
    const [editedValues, setEditedValues] = useState({});
    const [MonthSection, setMonthSection] = useState(generateMonthSection())
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [evalData, setEvalData] = useState({})
    const [totalProvision, setTotalProvision] = useState(0)
    const [payload, setPayload] = useState({
        filterType: "monthWise",
        fromDate: InitalDate("fromDate"),
        toDate: InitalDate("toDate"),
        monthWise: {
            monthName: getcurrentMonth("name"),
            monthYear: getcurrentMonth("year"),
            startMonth: StartMonthValue,
            endMonth: getcurrentMonth("monthlast"),
        },
        nbfc: "",
        product: "",
        percent: "",
    })




    useEffect(() => {
        
        const updatedPayload = {
            ...payload,
            nbfc: commonFilters?.nbfc || ""
        }
        setPayload(updatedPayload)
        getloanCollectionReportMonthWiseBydateFn(updatedPayload)
    }, [commonFilters])

    const handlechange = (e, type) => {
        if (type == "filterType") {
            const obj = {
                ...payload,
                filterType: e.target.value,
                "fromDate": InitalDate("fromDate"),
                "toDate": InitalDate("toDate"),
                "monthWise": {
                    monthName: getcurrentMonth("name"),
                    monthYear: getcurrentMonth("year"),
                    startMonth: StartMonthValue,
                    endMonth: getcurrentMonth("monthlast"),
                }
            }
            setPayload(obj)
            getloanCollectionReportMonthWiseBydateFn(obj)
        }
        if(type == "nbfc"){
            handleCommonFilters(e.target.value,"nbfc")
        }
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const hnaldemonthclick = (d) => {

        const lastDate = getLastDateOfMonth(d?.monthName, d?.monthYear);
        const obj = {
            ...payload,
            "monthWise": {
                monthName: d?.monthName,
                monthYear: d?.monthYear,
                startMonth: StartMonthValue,
                endMonth: lastDate,
            }
        }
        setPayload(obj)
        getloanCollectionReportMonthWiseBydateFn(obj)
    }


    const getloanCollectionReportMonthWiseBydateFn = (data) => {
        let start = "";
        let end = ""
        if (data?.filterType == "dateWise") {
            start = moment(data?.fromDate).format("DD-MM-YYYY");
            end = moment(data?.toDate).format("DD-MM-YYYY");
        } else if (data?.filterType == "monthWise") {
            start = data?.monthWise?.startMonth;
            end = data?.monthWise?.endMonth;
        }
        setLoader(true)
        getloanCollectionReportMonthWiseBydate(start, end, data.nbfc, data.product, data.percent, {}, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setAPIData(callback?.data)
                setEditedValues(callback?.data)
                calculateProvision(callback?.data)
            } else {
                setAPIData([])
                setEditedValues([])
            }
        })
    }

    const handleApply = () => {
        getloanCollectionReportMonthWiseBydateFn(payload)
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleview = (type) => {
        setViewType(type)
    }

    const handleEditValue = (e, type) => {
        const value = e.target.value;
        const [monthName, fieldName] = type.split("-");
        if (fieldName == "Provision") {
            setEvalData((prev) => ({
                ...prev,
                [monthName]: value
            }))
        }
        setAPIData(prevData =>
            prevData.map(item => {
                if (item.Month_Name === monthName) {
                    return {
                        ...item,
                        [fieldName]: value
                    };
                }
                return item;
            })
        );

    }

    const handleCancel = () => {
        // setAPIData([...editedValues]);
        handleApply()
        setViewType("list");
    };


    const handleSave = (type) => {
        console.log("edit", editedValues, "api", APIData)
        const d = payload.monthWise.endMonth
        if (type == "lock") {
            const updatedArray = APIData.map((item, index) => {
                return {
                    ...item,


                    "month": item?.Month_Name,
                    "loanGiven": item?.Loan_Given,
                    "unDueTillDate": item?.Undue_Till_Date,
                    "overDueTillDate": item?.Overdue_Till_Date,
                    "dueAndRecd": item?.Due_And_Recieved,
                    "dueAndRecdPercentage": item?.Due_And_Recieved_Percent,
                    "loanOutstanding": item?.Loan_Outstanding,
                    "provisionPercentage": item?.Provision,
                    "provisionAmount": item?.Provision_Amount,
                    createdBy: admin?.emailId,
                    lock: true,
                };
            }).map(({ Month_Name, Loan_Given, Undue_Till_Date, Overdue_Till_Date, Due_And_Recieved, Due_And_Recieved_Percent, Loan_Outstanding, Provision, Provision_Amount, Is_Locked, ...rest }) => rest);
            console.log("und", updatedArray)
            setLoader(true)
            SaveUpdateLockProvisionData(d, updatedArray, callback => {
                setLoader(false)
                if (callback?.message == "success" && callback?.status == 200) {
                    setpopup({ show: true, popupStatus: "Data Locked Successfully" })
                    getloanCollectionReportMonthWiseBydateFn(payload)
                } else {
                    setpopup({ show: true, popupStatus: "Error Locking Data" })
                }
                removePopup()
            })

        } else if (type == "save") {
            const updatedArray = editedValues.map((item, index) => {
                return {
                    ...item,
                    "month": item?.Month_Name,
                    "loanGiven": item?.Loan_Given,
                    "unDueTillDate": item?.Undue_Till_Date,
                    "overDueTillDate": item?.Overdue_Till_Date,
                    "dueAndRecd": item?.Due_And_Recieved,
                    "dueAndRecdPercentage": item?.Due_And_Recieved_Percent,
                    "loanOutstanding": item?.Loan_Outstanding,
                    "provisionPercentage": item?.Provision,
                    "provisionAmount": item?.Provision_Amount,
                    createdBy: admin?.emailId,
                    lock: false,
                };
            }).map(({ Month_Name, Loan_Given, Undue_Till_Date, Overdue_Till_Date, Due_And_Recieved, Due_And_Recieved_Percent, Loan_Outstanding, Provision, Provision_Amount, Is_Locked, ...rest }) => rest);
            console.log("und", updatedArray)

            setLoader(true)
            SaveUpdateLockProvisionData(d, updatedArray, callback => {
                setLoader(false)
                console.log("call", callback)
                if (callback?.message == "success" && callback?.status == 200) {
                    setViewType("list")
                    setpopup({ show: true, popupStatus: "Data Saved Successfully" })
                    getloanCollectionReportMonthWiseBydateFn(payload)
                } else {
                    setpopup({ show: true, popupStatus: "Error Saving Data" })
                }
                removePopup()
            })

        } else if (type == "Evaluate") {
            console.log("evalData", evalData)
            let start = payload?.monthWise?.startMonth;
            let end = payload?.monthWise?.endMonth;
            setLoader(true)
            getloanCollectionReportMonthWiseBydate(start, end, payload.nbfc, payload.product, payload.percent, evalData, callback => {
                console.log("call", callback)
                setLoader(false)
                if (callback && callback?.message == "success" && callback?.status == 200) {
                    setAPIData(callback?.data)
                    setEditedValues(callback?.data)
                    calculateProvision(callback?.data)
                } else {
                    setAPIData([])
                    setEditedValues([])
                }
            })
        } else if (type == "UnLock") {
            const obj = APIData?.length
            const data = {
                "summaryMonth": APIData?.[obj - 1]?.Month_Name || "",
                "nbfcId": payload?.nbfc || "",
                "productId": payload?.product || ""
            }
            console.log("data", data)
            setLoader(true)
            UpdateUnlockSummaryData(data, callback => {
                setLoader(false)
                if (callback && callback?.message == "success" && callback?.status == 200) {
                    setpopup({ show: true, popupStatus: "Data UnLocked Successfully" })
                    handleApply()
                } else {
                    setpopup({ show: true, popupStatus: "Error UnLocking Data" })
                }
                removePopup()
            })

        }
    }

    const calculateProvision = (data) => {
        const value = data?.reduce((total, el) => total + (Number(el?.Provision_Amount)), 0)
        console.log("al", value)
        setTotalProvision(value)
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} /> : ''
            }
            <div style={{ position: "absolute", marginLeft: '15px', marginTop: '17px', display: 'inline-block' }}>
                <h4 style={{ backgroundColor: APIData?.[0]?.Is_Locked == "false" ? "green" : "red", color: '#fff', padding: '10px', borderRadius: '8px', fontSize: '15px' }}>Status: {APIData?.[0]?.Is_Locked == "false" ? "Unlocked" : "Locked"}</h4>
            </div>

            <div style={{ position: "absolute", right: 0, display: 'inline-block' }}>
                <div className='count-div' style={{ width: '150px' }}>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <button className="btn-count-new" ><div style={{ fontSize: '14px', color: '#1D3557', fontWeight: '700' }}>PROVISION<br /> AMOUNT <br /><br /></div> <span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>{(Number(totalProvision))?.toLocaleString("en-US") || 0}</span></button>
                        </div>
                    </div>

                </div>
            </div>


            <div className='MISDashboard' style={{ marginTop: '85px' }}>
                <div className='Sections' style={{ marginTop: '30px', padding: '0' }}>
                    <div className="subSections" style={{ position: 'relative' }}>
                        <div className="row">
                            {/* <div className="col-xs-2 col-xs-6">
                                <label htmlFor="">Filter Type</label>
                                <select className='form-control' value={payload?.filterType} onChange={(e) => handlechange(e, "filterType")}>
                                    <option value={''}>Select Option</option>
                                    <option value={'dateWise'}>Date Wise</option>
                                    <option value={'monthWise'}>Month Wise</option>
                                </select>
                            </div> */}
                            {
                                payload?.filterType == "dateWise" ?
                                    <>
                                        <div className="col-xs-2 col-xs-6">
                                            <label htmlFor="">From</label>
                                            <input type="date" className='form-control' value={payload?.fromDate} onChange={(e) => handlechange(e, "fromDate")} />
                                        </div>
                                        <div className="col-xs-2 col-xs-6">
                                            <label htmlFor="">To</label>
                                            <input type="date" className='form-control' value={payload?.toDate} onChange={(e) => handlechange(e, "toDate")} />
                                        </div>
                                    </>
                                    : ''}

                            <div className="col-xs-2 col-xs-6">
                                <label htmlFor="">NBFC</label>
                                <select className='form-control' value={payload?.nbfc} onChange={(e) => handlechange(e, "nbfc")}>
                                    <option value={""}>Select NBFC</option>
                                    {
                                        nbfcList && nbfcList?.length > 0 ? nbfcList?.map((data, index) => {
                                            return (
                                                <option value={data?.nbfcId}>{data?.name}</option>
                                            )
                                        })
                                            : ''}
                                </select>
                            </div>
                            {/* <div className="col-xs-2 col-xs-6">
                                <label htmlFor="">Product</label>
                                <select className='form-control' value={payload?.product} onChange={(e) => handlechange(e, "product")}>
                                    <option value={""}>Select Product</option>
                                    <option value={"loan"}>Loan</option>
                                </select>
                            </div> */}
                            <div className="col-xs-4 col-xs-6">
                                <div className="" style={{ display: "flex" }}>
                                    <button className='btn btn-primary' style={{ padding: '11px 10px', marginTop: '20px', marginRight: '10px' }} onClick={() => handleApply()}>Filter</button>
                                    {
                                        viewType !== "edit" ?
                                            APIData?.[0]?.Is_Locked == "false" ?
                                                <>
                                                    <button className="btn btn-primary" style={{ marginTop: '20px', padding: '11px 10px', marginRight: '10px' }} onClick={() => handleview("edit")}>Edit</button>
                                                    <button className="btn btn-primary" style={{ marginTop: '20px', padding: '11px 10px' }} onClick={() => handleSave("lock")}>Lock</button>
                                                </>
                                                : ''
                                            : ''}
                                    {
                                        APIData?.[0]?.Is_Locked == "true" ?
                                            <button className="btn btn-primary" style={{ marginTop: '20px', padding: '11px 10px' }} onClick={() => handleSave("UnLock")}>Unlock</button>
                                            : ""}
                                </div>
                            </div>


                            {
                                payload?.filterType == "monthWise" ?
                                    <div className="col-xs-3 col-xs-12" style={{ float: 'right' }}>
                                        {/* <label htmlFor="">Month</label> */}
                                        <div style={{ width: '100%', borderRadius: '6px', border: '1px solid #006c67', display: 'flex' }}>
                                            {/* <button style={{ padding: '7px 3px 2px 3px', background: '#006c67', color: '#fff', borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }} onClick={handlePrevMonths}><KeyboardDoubleArrowLeftIcon /></button> */}
                                            <div style={{ padding: '6px', display: 'flex', width: '100%', overflowX: 'auto', scrollbarWidth: 'thin' }}>
                                                {
                                                    MonthSection && MonthSection?.length > 0 ?
                                                        // MonthSection.slice(visibleStartIndex, visibleStartIndex + visibleCount).map((value, index) => (
                                                        MonthSection.map((value, index) => (
                                                            <div className="monthTabs" style={{ background: (payload?.monthWise?.monthName == value?.monthName && payload?.monthWise?.monthYear == value?.monthYear) ? 'linear-gradient(180deg, rgb(173 75 75 / 10%) -60%, #006c67 100%)' : 'linear-gradient(135deg, rgba(173, 75, 75, 0.1) 0%, rgb(215 215 215) 100%)', borderRadius: '6px', padding: '10px', cursor: 'pointer', marginRight: '6px', color: (payload?.monthWise?.monthName == value?.monthName && payload?.monthWise?.monthYear == value?.monthYear) ? "#fff" : "#000" }} onClick={() => hnaldemonthclick(value)}>

                                                                <h5 style={{ margin: '0 0 5px 0', fontSize: '12px', textAlign: 'center' }}>{value?.monthName}</h5>
                                                                <h6 style={{ margin: '0 0 0 0', fontSize: '10px', textAlign: 'center' }}>{value?.monthYear}</h6>
                                                            </div>
                                                        )
                                                        )
                                                        : ''}
                                            </div>
                                            {/* <button style={{ padding: '7px 3px 2px 3px', background: '#006c67', color: '#fff', borderTopRightRadius: '6px', borderBottomRightRadius: '6px' }} onClick={handleNextMonths} ><KeyboardDoubleArrowRightIcon /></button> */}
                                        </div>
                                    </div>
                                    : ''}

                        </div>

                        <div className="row" style={{ marginTop: '20px' }}>
                            {
                                viewType === "edit" ?
                                    <div className="col-sm-2" style={{ float: 'right', textAlign: 'end' }}>
                                        <button className='btn btn-primary' style={{ marginRight: '10px', padding: '11px 12px' }} onClick={() => handleSave("Evaluate")}>Evaluate</button>
                                    </div>
                                    : ''}
                        </div>

                        <div className="Dashboardsmis" style={{ marginTop: '10px' }}>

                            <div className="row" style={{ position: 'relative' }}>
                                <div className="col-xs-12">
                                    <div className="table" style={{ marginTop: '20px' }}>
                                        <div className="phocket-table-new newTable" style={{ overflowX: 'auto', marginTop: '0px' }}>

                                            {
                                                APIData && APIData?.length > 0 ?
                                                    <table>
                                                        <thead style={{ position: 'sticky', top: 0 }}>
                                                            <tr >
                                                                <th style={{ position: 'sticky', left: 0, zIndex: '1' }}>Month</th>
                                                                <th>Provision</th>
                                                                <th>Loan Given</th>
                                                                <th>Loan Given This Month</th>
                                                                <th>Due And Recieved Percent</th>
                                                                <th>Due And Recieved</th>
                                                                {/* <th>Overdue Till Date</th> */}
                                                                <th>Overdue</th>
                                                                <th>Undue Till Date</th>
                                                                <th>Loan Outstanding</th>
                                                                <th>Provision Amount</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                APIData?.map((value, index) => {

                                                                    return (
                                                                        <tr>
                                                                            <td className='leftsticky'>{value?.Month_Name}</td>
                                                                            <td>
                                                                                {
                                                                                    viewType === "edit" ?
                                                                                        <input style={{ width: '100%', borderRadius: '6px', border: '1px solid #000', padding: '7px' }} type='number' className='' value={value?.Provision} onChange={(e) => handleEditValue(e, `${value?.Month_Name}-Provision`)} />
                                                                                        :
                                                                                        Number(value?.Provision)
                                                                                }

                                                                            </td>
                                                                            <td>
                                                                                {Number(value?.Loan_Given)?.toLocaleString("en-US")}
                                                                            </td>
                                                                            <td>
                                                                                {Number(value?.Loan_Given_This_Month)?.toLocaleString("en-US")}
                                                                            </td>
                                                                            <td>
                                                                                {/* {
                                                                                    viewType === "edit" ?
                                                                                        <input style={{ width: '100%', borderRadius: '6px', border: '1px solid #000', padding: '7px' }} type='number' className='' value={value?.Due_And_Recieved_Percent} onChange={(e) => handleEditValue(e, `${value?.Month_Name}-Due_And_Recieved_Percent`)} />
                                                                                        :
                                                                                        Number(value?.Due_And_Recieved_Percent)
                                                                                } */}
                                                                                {Number(value?.Due_And_Recieved_Percent)}
                                                                            </td>
                                                                            <td>
                                                                                {Number(value?.Due_And_Recieved_This_Month)?.toLocaleString("en-US")}
                                                                            </td>
                                                                            {/* <td>
                                                                                {Number(value?.Overdue_Till_Date)?.toLocaleString("en-US")}
                                                                            </td> */}
                                                                            <td>
                                                                                {Number(value?.Overdue_This_Month)?.toLocaleString("en-US")}
                                                                            </td>
                                                                            <td>
                                                                                {Number(value?.Undue_Till_Date)?.toLocaleString("en-US")}
                                                                            </td>
                                                                            <td>
                                                                                {Number(value?.Loan_Outstanding)?.toLocaleString("en-US")}
                                                                            </td>
                                                                            <td>{Number(value?.Provision_Amount)?.toLocaleString("en-US")}</td>

                                                                        </tr>
                                                                    )
                                                                })}

                                                        </tbody>
                                                    </table>
                                                    : ''}
                                        </div>
                                    </div>
                                </div>

                                {
                                    viewType === "edit" ?
                                        <div className="col-xs-12 text-center">
                                            <button className='btn btn-primary' style={{ marginRight: '10px' }} onClick={() => handleCancel()}>Cancel</button>

                                            <button className='btn btn-primary' onClick={() => handleSave("save")}>Save</button>
                                        </div>
                                        : ''}

                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
